package org.example.zone360.pages.coachDetails.coachPlayerList

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.BSTooltip
import com.stevdza.san.kotlinbs.components.initializeTooltips
import com.stevdza.san.kotlinbs.models.TooltipDirection
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronDown
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.icons.fa.FaInfo
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetPlayerData
import org.example.zone360.pages.dashboard.playerAssessment.AddNewPlayer
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachPlayerList(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    selectedTeam: List<String>,
    message: (String) -> Unit,
    coachPlayerList: List<GetPlayerData>,
    isLoading: Boolean,
    onPlayerAdded: (List<GetPlayerData>) -> Unit,
    disable:Boolean
){

    var isExpanded by remember { mutableStateOf(false) }
    val expandedHeight = if (isExpanded) {500.px} else{ 0.px}
    var addNewPlayer by remember { mutableStateOf(false) }

    if (addNewPlayer) {
        AddNewPlayer(
            onDialogDismiss = {
                addNewPlayer = false
            },
            breakpoint = breakpoint,
            modalNumber = 1,
            toastMessageCall = message,
            selectedTeamList = selectedTeam,
            teamData = AppGlobal.teamDataList,
            onPlayerAdded = onPlayerAdded,
            coachProfilePlayers = true
        )
    }

    Box(
        modifier = Modifier
            .margin(top = 10.px)
            .fillMaxWidth()
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(15.px)
            .overflow(
                overflowY = Overflow.Hidden,
                overflowX =   Overflow.Auto
            )
            .boxShadow(
                offsetY = 40.px,
                blurRadius = 72.px,
                color = sitePalette.textFieldTextColor.rgb.copy(alpha = 15)
            )
            .padding(20.px)
    ) {
        Column(
            modifier = Modifier.width(100.percent)
                .fillMaxHeight()
        )  {
            Row(
                Modifier.fillMaxWidth()
                    .onClick {},
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (isExpanded) {
                    FaChevronDown(Modifier.cursor(Cursor.Pointer)
                        .onClick { isExpanded = false })
                } else {
                    FaChevronRight(Modifier.cursor(Cursor.Pointer)
                        .onClick { isExpanded = true })
                }
                CustomSpacer(15.px)
                FieldTitleTextNormalSimple(
                    "Players",
                    fontSize = 20.px,
                    fontWeight = 600,
                    onClick ={isExpanded = !isExpanded}
                )
                Spacer()
                if (isExpanded && !disable) {
                    CommonButton(
                        text = "Add New Player",
                        icon = { FaPlus(size = IconSize.X1,
                            modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb))},
                        width = 150.px,
                        height = 40.px,
                        onCLick = {
                            addNewPlayer = true

                        })
                }
            }

                if (isExpanded) {
                    val modifier = if (breakpoint >= Breakpoint.MD) Modifier.height(expandedHeight) else Modifier
                    Column(
                        modifier = modifier.fillMaxWidth()
                            .transition(
                                Transition.of(
                                    property = "height",
                                    duration = 300.ms,
                                    timingFunction = AnimationTimingFunction.EaseInOut
                                )
                            )
                    ) {
                        if (breakpoint >= Breakpoint.MD) {
                            Row(
                                modifier = Modifier.fillMaxWidth().height(50.px)
                                    .backgroundColor(sitePalette.coachesTitleRow.rgb),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .padding(leftRight = 10.px),
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.SpaceBetween
                                ) {
                                    Column(modifier = Modifier.width(150.px)) {
                                        FieldTitleTextNormalSimple(
                                            text = "Name",
                                            width = 100.percent,
                                            fontWeight = 500,
                                            fontSize = 15.px
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = "Team",
                                            width = 100.percent,
                                            fontWeight = 500,
                                            fontSize = 12.px,
                                            color = sitePalette.infoIconColor.rgb
                                        )
                                    }
                                    FieldTitleTextNormalSimple(
                                        text = "Position",
                                        width = 150.px,
                                        fontWeight = 500,
                                        isClickable = true,
                                        textAlign = TextAlign.Center,
                                    )

                                    FieldTitleTextNormalSimple(
                                        text = "Age",
                                        width = 90.px,
                                        fontWeight = 500,
                                        textAlign = TextAlign.Center,

                                        )

                                    FieldTitleTextNormalSimple(
                                        text = "Assessments",
                                        width = 90.px,
                                        fontWeight = 500,
                                        textAlign = TextAlign.Center,
                                    )
                                    LaunchedEffect(Unit) {
                                        initializeTooltips()

                                    }
                                    Row(
                                        modifier = Modifier.width(200.px),
                                        verticalAlignment = Alignment.CenterVertically,
                                        horizontalArrangement = Arrangement.Center
                                    ) {
                                        CustomSpacer(20.px)
                                        FieldTitleTextNormalSimple(
                                            text = "Avg. Rating",
                                            fontWeight = 500,
                                            textAlign = TextAlign.Center
                                        )
                                        BSTooltip(
                                            text = "You can change the individual session rating in the player profile",
                                            direction = TooltipDirection.Top,
                                            content = {
                                                Box(
                                                    modifier = Modifier
                                                        .width(17.px)
                                                        .height(17.px)
                                                        .backgroundColor(Colors.LightGray)
                                                        .cursor(Cursor.Pointer)
                                                        .borderRadius(100.px)
                                                        .margin(leftRight = 10.px),
                                                    contentAlignment = Alignment.Center
                                                ) {
                                                    FaInfo(
                                                        modifier = Modifier.color(Colors.White)
                                                            .cursor(Cursor.Pointer),
                                                        size = IconSize.XXS
                                                    )
                                                }
                                            }
                                        )
                                    }
                                    FieldTitleTextNormalSimple(
                                        text = "Recommendations",
                                        width = 120.px,
                                        fontWeight = 500,
                                        isClickable = false,
                                        textAlign = TextAlign.Center
                                    )
                                }
                            }
                        }

                        Box(modifier = Modifier.fillMaxWidth().height(1.px)
                            .backgroundColor(sitePalette.searchBackground.rgb))
                    Column(
                        modifier = Modifier.fillMaxWidth().maxHeight(420.px)
                            .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
                    ) {

                        CoachPlayerRow(
                            sitePalette,
                            breakpoint,
                            coachPlayerList,
                            isLoading)
                    }
                }
            }
        }
    }
}

